import { reactive } from "vue"

export default function (data) {
  const Instance = {}
  reactive(Instance, "reactive", data)

  return Instance.reactive
}
